import React from "react";

interface RadioGroupProps {
  label?: string;
  required?: boolean;
  children: React.ReactNode;
  error?: any;
  requiredMessage?: string;
}

const RadioGroup: React.FC<RadioGroupProps> = ({
  label,
  required = false,
  children,
  error
}) => {
  return (
    <div className="form-group">
      {label && (
        <label className="fw-600 black">
          {label}{" "}
          {required && <span className="text-danger">*</span>}
        </label>
      )}

      <div className="d-flex flex-wrap align-items-center gap-4 mt-1">
        {children}
      </div>

      {error && (
        <p className="error-text">{error.message}</p>
      )}
    </div>
  );
};

export default RadioGroup;
